<template>
    <div class="py-5" v-if="!support_lib_id">
        <Loading ></Loading>
    </div>
    <iframe v-else :src="'https://app.modalsupport.com/AdvancedWidget/'+support_lib_id" class="widget" frameborder="0"></iframe>
</template>
<script>
import { projectFirestore, timestamp } from '@/firebase/config';
import Loading from "@/components/custom/Loading.vue";
import { ref } from "vue";
    export default {
        name:'Preview',
        components:{
            Loading
        },
        setup() {
            const support_lib_id = ref(localStorage.getItem('support_Lib_id'));
            return {
                support_lib_id
            }
        }
    }
</script>
<style>
    /* .widget {
        width: 100%;
        height: 98vh;
    } */
</style>